// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsents_root__3EZQq","consentsList":"PatientConsents_consentsList__m7zG_","consentsListEmpty":"PatientConsents_consentsListEmpty__3XhP8"};